import React from 'react';
import styles from './index.module.css';
import * as translations from './strings';
import { getLangKey } from '../../models/Language';
import { Sparkles } from 'lucide-react';
import bannerImage from './img-ai-settings-pattern.png';
import cx from 'classnames';

const strings = translations[getLangKey()];

type Props = {
  inAiBeta: boolean;
  orgSettings?: boolean;
};

export const AIBanner = ({ inAiBeta, orgSettings }: Props) => {
  return (
    <div
      className={cx(styles.aiBanner, {
        [styles.centerAligned]: !inAiBeta
      })}
    >
      <span className={styles.betaTag}>{strings.beta}</span>
      <h1 className={styles.aiBannerTitle}>
        <Sparkles className={styles.sparklesIcon} />
        {strings.aiBannerTitle}
      </h1>
      {inAiBeta && (
        <p className={styles.aiBannerDescription}>
          {strings.aiBannerDescription}
        </p>
      )}
      <img
        className={cx({
          [styles.orgSettingsBannerImage]: orgSettings,
          [styles.aiBannerImage]: !orgSettings
        })}
        src={bannerImage}
        alt="AI Settings Banner"
      />
    </div>
  );
};
